import React, { useState, useContext, useEffect } from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";
import BookingServices from "services/BookingServices";
import { notifyError, notifySuccess } from "utils/toast";
import LabelArea from "components/form/LabelArea";
import { SidebarContext } from "context/SidebarContext";
import SelectExecutives from "components/form/SelectExecutives";

const TourDepatureexecutemodal = ({ isOpen, onClose, client_id, data }) => {
  const [selectedDepartureEmployee, setSelectedDepartureEmployee] = useState(null);
  const { setIsUpdate } = useContext(SidebarContext);
  const [departureVendorName, setDepartureVendorName] = useState(null);
  const [tourType, setTourType] = useState("");
  const [options, ] = useState([]); // To hold options for the dropdown
  let result = null;

  // Find the client data for the provided client_id
  data.forEach((clientData) => {
    Object.keys(clientData).forEach((clientKey) => {
      if (String(clientData.client_id) === String(client_id)) {
        result = clientData; 
      }
    });
  });

  useEffect(() => {
    
    if (result?.departure_executive?.trim() !== "") {
     
      setDepartureVendorName(result?.departure_executive);
            } else {
              setDepartureVendorName(null);
            }
      
  }, [result]);

  // Update selectedDepartureEmployee when departureVendorName changes
  useEffect(() => {
    if (departureVendorName) {
      setSelectedDepartureEmployee(
        options?.find((option) => option.label === departureVendorName)?.value || null
      );
    }
  }, [departureVendorName, options]);

  const handleDepartureChange = (employeeId) => {
    setSelectedDepartureEmployee(employeeId);
    setTourType("2"); 
  };

  const handleConfirm = async () => {
    if (!selectedDepartureEmployee) {
      notifyError("Please select an executive.");
      return;
    }

    try {
      const payload = { employee_id: selectedDepartureEmployee };
      const response = await BookingServices.Assignexecutive(client_id,  tourType , payload);

      if (response.status) {
        notifySuccess(response.message);
      } else {
        notifyError(response.message);
      }

      setIsUpdate(true);
      onClose();
    } catch (error) {
      console.error("Error updating status:", error);
      notifyError("Error updating status.");
    }
  };

  const resetModal = () => {
    setSelectedDepartureEmployee(null);
    setTourType("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={resetModal}>
      <ModalBody>
        <p className="text-lg font-bold text-center">
          Departure Tour Executive
        </p>

        {/* Departure Dropdown */}
        <div className="grid grid-cols-6 gap-4 mb-6">
          <LabelArea label="Departure" />
          <div className="col-span-4">
            <SelectExecutives
              client_id={client_id}
              label="Departure Executive"
              handleReferenceNoChange={handleDepartureChange}
              employee_name={departureVendorName}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3 mt-4">
          <Button className="bg-green-500 text-white" onClick={handleConfirm}>
            Update
          </Button>
          <Button className="bg-gray-500 text-white" onClick={resetModal}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TourDepatureexecutemodal;
